import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Label,
  ErrorText,
  StyledSelect,
} from './components/SelectStyles';
import { useSelect } from './hooks/useSelect';
import { normalizeOptions } from './utils/selectHelpers';

const Select = ({ size, disabled, options, value, onChange, label, error, ...rest }) => {
  const { handleChange } = useSelect({ onChange, disabled });
  const formattedOptions = normalizeOptions(options);

  return (
    <Container>
      {label && <Label disabled={disabled}>{label}</Label>}
      <StyledSelect
        size={size}
        disabled={disabled}
        value={value}
        onChange={handleChange}
        hasError={!!error}
        {...rest}
      >
        {formattedOptions.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </StyledSelect>
      {error && <ErrorText>{error}</ErrorText>}
    </Container>
  );
};

Select.propTypes = {
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  disabled: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  label: PropTypes.string,
  error: PropTypes.string,
};

Select.defaultProps = {
  size: 'sm',
  disabled: false,
  value: undefined,
  onChange: undefined,
  label: undefined,
  error: undefined,
};

export default Select;



// WEBPACK FOOTER //
// ./src/design-system/atoms/Select/Select.jsx